<div id="messageBox">
  <mat-icon mat-dialog-title class="icon" [svgIcon]="getIconKey(settings.icon)"></mat-icon>
  <mat-dialog-content class="content main-content">
    <div>{{ settings.message }}</div>
    <div id="htmlCode"></div>
  </mat-dialog-content>
  <mat-dialog-actions class="button-container" fxLayoutAlign="center">
    <div *ngIf="settings.button === MessageBoxButtons.OK">
      <button class="buttonMessageBox" (click)="onClick(DialogResult.OK)" mat-button mat-dialog-close>
        {{ res('Ok') }}
      </button>
    </div>

    <div *ngIf="settings.button === MessageBoxButtons.OKCancel" fxLayoutAlign="center">
      <button fxFlex.sm="38" class="buttonMessageBox" (click)="onClick(DialogResult.OK)" mat-button mat-dialog-close>
        {{ res('Ok') }}
      </button>
      <button
        fxFlex.sm="38"
        class="buttonMessageBox"
        (click)="onClick(DialogResult.Cancel)"
        mat-button
        mat-dialog-close
      >
        {{ res('Cancel') }}
      </button>
    </div>

    <div *ngIf="settings.button === MessageBoxButtons.AbortRetryIgnore">
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Abort)" mat-button mat-dialog-close>
        {{ res('Abort') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Retry)" mat-button mat-dialog-close>
        {{ res('Retry') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Ignore)" mat-button mat-dialog-close>
        {{ res('Ignore') }}
      </button>
    </div>

    <div *ngIf="settings.button === MessageBoxButtons.YesNoCancel">
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Yes)" mat-button mat-dialog-close>
        {{ res('Yes') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.No)" mat-button mat-dialog-close>
        {{ res('No') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Cancel)" mat-button mat-dialog-close>
        {{ res('Cancel') }}
      </button>
    </div>

    <div *ngIf="settings.button === MessageBoxButtons.YesIgnoreCancel">
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Yes)" mat-button mat-dialog-close>
        {{ res('Yes') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Ignore)" mat-button mat-dialog-close>
        {{ res('Ignore') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Cancel)" mat-button mat-dialog-close>
        {{ res('Cancel') }}
      </button>
    </div>

    <div *ngIf="settings.button === MessageBoxButtons.YesNo">
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Yes)" mat-button mat-dialog-close>
        {{ res('Yes') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.No)" mat-button mat-dialog-close>
        {{ res('No') }}
      </button>
    </div>

    <div *ngIf="settings.button === MessageBoxButtons.RetryCancel">
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Retry)" mat-button mat-dialog-close>
        {{ res('Retry') }}
      </button>
      <button class="buttonMessageBox" (click)="onClick(DialogResult.Cancel)" mat-button mat-dialog-close>
        {{ res('Cancel') }}
      </button>
    </div>
  </mat-dialog-actions>
  <div *ngIf="settings.errorMessage" class="error-content">
    <mat-divider id="dividerMsgBox"></mat-divider>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="header" [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
        <mat-panel-title class="error-title">{{ errorMessageCaption }}</mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <pre id="error-message" #copyToClipboard>{{ settings.errorMessage }}</pre>
        <button mat-button class="copieren" (click)="toClipboard(settings.errorMessage)" mat-button>
          {{ res('Copy_Message') }}...
        </button>
      </ng-template>
    </mat-expansion-panel>
  </div>
</div>
